import React, { useState, useEffect } from "react";
import ButterflyMark from "./butterflyMark";

const ComponentContentLoader = React.memo(function ComponentContentLoader() {
  const [animation, setAnimation] = useState("");
  useEffect(() => {
    setAnimation("active");
    return () => {
      setAnimation("");
    };
  }, []);
  return (
    <div className={`content-loader-comp ${animation}`}>
      <div className="d-inline-block" style={{ zIndex: "999999" }}>
        <ButterflyMark />
      </div>
    </div>
  );
});

export default ComponentContentLoader;
